import React, { useCallback } from 'react';
import { DaysProps, DayTypeEnum } from './types';
import { DayContainer, ActualDayBullet, SpanDay } from './styles';

const Day: React.FC<DaysProps> = (props) => {
  const {
    day,
    onDayClick,
    onHoverDay,
    isFrom,
    isFromInterval,
    isTo,
    isEqual,
    type,
    isAvailable,
    isWeekend,
  } = props;
  const handleClick = useCallback(() => {
    if (isAvailable) {
      onDayClick(day);
    }
  }, [isAvailable, day, onDayClick]);
  const handleHover = useCallback(() => onHoverDay(day), [day, onHoverDay]);

  return (
    <DayContainer
      isFrom={isFrom}
      isTo={isTo}
      isFromInterval={isFromInterval}
      isEqual={isEqual}
    >
      {type === DayTypeEnum.ActualDay && (
        <ActualDayBullet isFrom={isFrom} isTo={isTo} />
      )}
      <SpanDay
        about="day"
        isFrom={isFrom}
        isTo={isTo}
        isFromInterval={isFromInterval}
        isEqual={isEqual}
        isBlocked={!isAvailable}
        isWeekend={isWeekend}
        type={type}
        role="presentation"
        onMouseDown={handleClick}
        onMouseEnter={handleHover}
      >
        {day}
      </SpanDay>
    </DayContainer>
  );
};

export default Day;
